import {Component, OnInit} from '@angular/core';
import {LabelService} from '../../services/label.service';
import {Label} from '../../model/Label';
import {Observable} from 'rxjs';
import {AdminPageModelComponent} from "../../components/admin/admin-page-model/admin-page-model.component";
import {BadgeComponent} from "../../components/common/badge/badge.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CommonModule} from "@angular/common";
import {DynamicModalFormComponent} from "../../components/common/dynamic-modal-form/dynamic-modal-form.component";
import {LabelFormGeneratorService} from "../../formulaires/admin/label-form-generator.service";
import {ColorContrastComponent} from "../../components/admin/color-contrast/color-contrast.component";
import {DynamicTableComponent} from "../../components/common/dynamic-table/dynamic-table.component";

@Component({
    selector: 'app-label',
    templateUrl: './label.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        AdminPageModelComponent,
        DynamicModalFormComponent,
        BadgeComponent,
        ColorContrastComponent,
        DynamicTableComponent
    ],
    styleUrls: ['./label.component.css']
})
export class LabelComponent implements OnInit {
  labels: Observable<Label[]>;

  // Currently edited label
  toEdit: Label;
  // Currently deleted label
  toDelete: Label;

  // Actions on table
  tableActions = [
    {
      icon: 'pen',
      eventHandler: (item) => this.toEdit = Object.assign({}, item),
      cssClass: 'text-info',
      tooltip: 'Modifier'
    },
    {
      icon: 'trash-alt',
      eventHandler: (item) => this.toDelete = Object.assign({}, item),
      cssClass: 'text-danger',
      tooltip: 'Supprimer'
    },
  ];

  // Table headers and sorting ['Aperçu', 'Nom', 'Couleur de fond', 'Couleur de texte', 'Accessibilité']
  tableaHeaders = [
    { label: "Aperçu" },
    {
      label: "Nom",
      sortable: true,
      property: 'name',
    },
    { label: 'Couleur de fond' },
    { label: 'Couleur de texte' },
    { label: 'Accessibilité' }
  ]

  constructor(private labelService: LabelService,
              public labelFormGeneratorService: LabelFormGeneratorService) {
  }

  ngOnInit(): void {
    this.labels = this.labelService.getObjects();
  }

  create(): void {
    this.toEdit = new Label();
    this.toEdit.backcolor = '#000000';
    this.toEdit.textcolor = '#FFFFFF';
  }

  save(label: Label): void {
    this.labelService.createObject(label);
  }

  remove(): void {
    this.labelService.deleteObject(this.toDelete);
    this.toDelete = undefined;
  }
}

